
<div>
  <p class="errorText" *ngIf="showSuccess">The item has been successfully deleted.</p>
  <p class="errorText" *ngIf="ShowAdded">The item has been successfully added.</p>
  <div class="section-wrapper tabletab">
    <p-tabView (onChange)="tabClick()">
      <p-tabPanel header="OMC By User ID">
        <div>
          <p class="tabTitle">OMC Maintenance - By User ID</p>
          <div class="d-flex text-center justify-center">
            <p class="tabTitle">Select OMC</p>
            <p-dropdown
              [options]="omcOptionsUser"
              [(ngModel)]="selectedOMCUser"
              (onChange)="filterChangeUser($event)"
              placeholder="Select OMC"
              class="ml-10"
              
            ></p-dropdown>
            <p class="ml-10 tabTitle">{{ selectedOMCName }}</p>
          </div>
          <p-table
            [value]="filterUserIdomcData"
            scrollHeight="400px"
            scrollable="true"
            [paginator]="true"
            [rows]="20"
            styleClass="p-datatable-gridlines mt-10"
            [frozenWidth]="'500px'"
            id="StyleTable"
          >
            <ng-template pTemplate="header">
              <tr>
                <th>
                  Facility
                </th>
                <th>OMC User ID
                </th>
                <th>                  Plant Maximo
                </th>
                <th>                  Plant Maximo Name 
                </th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td>{{ row.facilityID }}</td>
                <td>{{ row.cai }}</td>
                <td>{{ row.plantMaximo }}</td>
                <td>{{ row.plantName }}</td>
                <td>
                  <button pButton class=" primary-btn h-30"  (click)="DeleteOmc(row)">
                    Delete
                  </button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-tabPanel>
      <p-tabPanel header="OMC By Plant">
        <div>
          <p class="tabTitle">OMC Maintenance - By Plant</p>
          <div class="d-flex text-center justify-center">
            <p class="tabTitle">Select Plant</p>
            <p-dropdown
              [options]="omcOptionsPlant"
              [(ngModel)]="selectedOMCPlant"
              (onChange)="filterChangePlant($event)"
              placeholder="Select OMC"
            ></p-dropdown>
          </div>
          <p-table
            [value]="filterPlantomcData"
            styleClass="p-datatable-gridlines mt-10"
            [frozenWidth]="'500px'"
            id="StyleTable"
          >
            <ng-template pTemplate="header">
              <tr>
                <th>Facility</th>
                <th>Plant Maximo</th>
                <th>Plant Maximo Name</th>
                <th>OMC User ID</th>
                <th>Name</th>
                <th>Email</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td>{{ row.facilityID }}</td>
                <td>{{ row.plantMaximo }}</td>
                <td>{{ row.plantName }}</td>
                <td>{{ row.cai }}</td>
                <td >
                  {{ row.displayName }}</td>
                <td >{{ row.email }}</td>
                <td>
                  <button pButton class="primary-btn h-30"  (click)="DeleteOmc(row)">
                    Delete
                  </button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="4" class="text-center">No TLRs assigned to you</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-tabPanel>
      <p-tabPanel header="All OMC User ID and Plant">
        <p class="tabTitle">OMC Maintenance - All OMC User ID and Plant</p>
        <p-table
          [value]="omcWholeData"
          [paginator]="true"
          [rows]="10"
          scrollHeight="400px"
          id="StyleTable"
          styleClass="p-datatable-gridlines mt-10"
          [frozenWidth]="'500px'"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Facility</th>
              <th >OMC User ID</th>
              <th >Name</th>
              <th >Email</th>
              <th>Plant Maximo</th>
              <th>Plant Maximo Name</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>{{ row.facilityID }}</td>
              <td>{{ row.cai }}</td>
              <td>{{ row.displayName }}</td>
              <td>{{ row.email }}</td>
              <td>{{ row.plantMaximo }}</td>
              <td>{{ row.plantName }}</td>
              <td>
                <button pButton  class="primary-btn h-30"  (click)="DeleteOmc(row)">
                  Delete
                </button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
      <p-tabPanel header="Add OMC User ID ">
        <div class="air-details-container">
          <div class="section-title">Enter OMC User ID Data</div>
          <div class="partioned-table">
            <div class="row">
              <div class="cell label">
                <p class="cellValue">Facility</p>
              </div>
              <div class="cell value">
                <p class="tabTitle">{{ facilityName }}</p>
              </div>
            </div>
            <div class="row">
              <div class="cell label">
                <p class="cellValue">OMC User ID:</p>
              </div>
              <div class="cell value d-flex-column">
                <div class="d-flex">
                  <input [(ngModel)]="userIdEntered" (keydown.enter)="verifyUserId()" maxlength="100" style="width : 200px" />
                  <p class="red" *ngIf="requiredFlag">* required</p>
                <button class="baseBtn primary-btn" (click)="verifyUserId()">
                  Verify User ID
                </button>
                <p class="red ml-10">* enter user email </p>
                </div>
                <br />
                <div class="d-flex-column">
                  <p *ngIf="userName" class="m-0 tabTitle">{{ userName }}</p>
                  <p *ngIf="useremail" class="m-0 tabTitle">{{ useremail }}</p>
                  <p class="red" *ngIf="validUserEntered">enter valid userId</p>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="isValid">
              <div class="cell label">
                <p class="cellValue">Select Plan Maximo:</p>
              </div>
              <div class="cell value">
                <div class="maxHeight">
                  <div *ngFor="let maximo of maximoList" class="field-checkbox">
                    <p-checkbox
                      [(ngModel)]="selectMaximos"
                      [label]="maximo.plantName"
                      name="group"
                      [value]="maximo"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="isValid">
              <div class="cell label"></div>
              <div class="cell value">
                <p-button
                  label="Add New OMC User ID"
                  class="primary-btn h-30"
                  (click)="addNewOMC()"
                ></p-button>
                <p class="red" *ngIf="selectValidMaximo">select atleast one maximo</p>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>
